var $$model_comment = require('model/comment');
var $$list_tpl = require('./item.tpl');
var $$config = require('config');
var LoadMore = require('assets/loadMore');

$(function () {
    var $mod = $('.module-pannel-comment');
    var pageNo = 1;
    var uid = +$('[node-type="comment-list"]').attr('data-uid');
    var hasMore = $('[node-type="comment-list"]').attr('data-hasMore');
    var $dianpingList = $mod.find('[node-type="comment-list"]');
    var $commentMenus = $mod.find('[node-type="comment-menu"]');
    var loadMoreBtn = $mod.find('[node-type="load-more"]');

    // var userName = $mod.find('[node-type="dianping-username"]').val();

    var $$loadMore = new LoadMore({
        mod: $mod,
        btn: loadMoreBtn,
        hide: hasMore === 'false' || !hasMore,
        trigger: 'pcScroll'
    });

    var isLogin = function () {

        if (!window.focus_uid) {
            FCLogin.open();

            // window.location.href = $$config.loginUrl + '?ru=' + window.encodeURIComponent(window.location.href);
            return false;
        }
        return true;
    };
    var headerStarFn = function ($ele) { //点评评分星星
        var len = $ele.length,
            i;
        for (i = 0; i < len; i++) {
            var cur = $ele.eq(i);
            var score = cur.attr('data-score'),
                width = cur.width(),
                curWidth = width / 5 * score;
            cur.find('.star-cnt').width(curWidth);
        }
    };

    var dianZan = function () {

        $mod.on('click', '[node-type="dianping-zan"]', function () {
            if ($(this).data('voted')) {
                return;
            }
            var $zanCount = $(this).find('.bottom-zan-num');
            $zanCount.html(+$zanCount.html() + 1);
            $(this).data('voted', true)
        })
    };

    var commentInput = function () {
        $mod.delegate("input[node-type='comment-input']", "input propertychange change",
            function () {
                var _this = window.$(this);
                var val = _this.val().toString();
                if (val.length > 0) {
                    $mod.find('[node-type="comment-btn"]').removeClass('disabled');
                } else {
                    $mod.find('[node-type="comment-btn"]').addClass('disabled');
                }
            });
    };
    var commentFn = function () { //回复按钮
        $dianpingList.delegate('[node-type="dianping-comment"]', 'click', function () {
            // if (!isLogin()) {
            //     return;
            // }
            var $this = $(this);
            var $parent = $this.parents('[node-type="dianping-list-item"]'),
                $commentMenu = $parent.find('[node-type="comment-menu"]');
            if ($commentMenu.is(':visible')) {
                $commentMenu.hide();
            } else {
                $commentMenus.hide();
                $commentMenu.show();
            }
        });
    };

    var commentMenuFn = function () { //回复下拉菜单
        $dianpingList.delegate('[node-type="comment-btn"]', 'click', function () {
            var $this = $(this);

            if ($this.hasClass('disabled')) {
                return;
            } else {
                $this.addClass('disabled');
            }

            var $input = $this.siblings('[node-type="comment-input"]'),
                $parent = $this.parents('[node-type="comment-menu"]'),
                $comment = $this.parents('[node-type="dianping-list-item"]').find(
                    '[node-type="dianping-comment"]');
            var commentId = +$parent.attr('data-id'),
                content = $input.val().trim(),
                commentNum = $comment.find('.bottom-comment-num').html();
            if (content === '') {
                //为空提示
                window.toast('请输入点评内容');
                $this.removeClass('disabled');
                return;
            } else if (content.length < 10) {
                window.toast('最少输入10个字');
                $this.removeClass('disabled');
                return;
            } else if (content.length > 200) {
                window.toast('最多输入200个字');
                $this.removeClass('disabled');
                return;
            } else {
                $$model_comment.replyUserDianping(commentId, content, function (
                    res) {
                    if (res.code === '200') {
                        var data = {
                            "name": "我",
                            "replyTxt": content
                        };
                        var $$tmpl = require('./comment.tpl');
                        $parent.find('[node-type="comment-cnt"]').prepend(
                            velocityjs.render($$tmpl, data));
                        $input.val('');
                        $comment.addClass('light').find(
                            '.bottom-comment-num').html(++
                            commentNum);
                        $this.addClass('disabled');
                        window.toast('发送成功');
                    } else {
                        if (!focus_uid) {
                            window.toast('请先登录');
                        } else {
                            window.toast('发送失败');
                        }
                    }
                    $this.removeClass('disabled');
                });
            }
        });
    };


    $$loadMore.trigger(function () {
        $$model_comment.getMoreComment(uid, ++pageNo, 10, getMoreCommentCb);

    });
    // 监听回调函数
    function getMoreCommentCb(data) {

        if (data.code === "200" || data.code === 200) {

            var context = {

                'commentInfo': {
                    'list': data.data.list

                },
                'focus_domain': $mod.data('domain'),
                'PHOTO_DOMAIN': $mod.attr('data-photoDomain'),
                'dftLoupanImg': $mod.attr('data-dftImg'),
                'PHOTO_STYLE_H': $mod.attr('data-photoStyle')
            };

            $$loadMore.renderMore($$list_tpl, context, $mod.find(
                '[node-type="comment-list"]'));

            headerStarFn($mod.find('[node-type="dianping-list-star"]'));


            if (data.data.hasNext === 'false') {
                $$loadMore.noMore();

                return;
            }
            $$loadMore.show();

        } else {
            $$loadMore.hide();

        }
    };

    headerStarFn($mod.find('[node-type="dianping-list-star"]'));
    headerStarFn($mod.find('[node-type="dianping-header-star"]'));
    commentFn();
    commentInput();
    commentMenuFn();
    dianZan();

});



// WEBPACK FOOTER //
// ./src/module/pannel-comment/pannel-comment.js